import { createAction, props } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { CommonAtcViewModel } from 'src/app/model/common/atc.view';
import { CommonMedicineViewModel } from 'src/app/model/common/medicine.view';

enum CommonAtcActionLabels {
  SET_PAGED_RESULT = 'COMMON_ATC_SET_PAGED_RESULT',
  SET_LIST_RESULT = 'COMMON_ATC_SET_LIST_RESULT',
  SET_MEDICINE_RESULT = 'COMMON_ATC_SET_MEDICINE_RESULT',
  ADD_MEDICINE_RESULT = 'COMMON_ATC_ADD_MEDICINE_RESULT',
  SET_ALL_DEFAULT = 'COMMON_ATC_SET_ALL_DEFAULT',
}

export const commonAtcActions = {
  setPagedResultAction: createAction(
    CommonAtcActionLabels.SET_PAGED_RESULT,
    props<{ result: VonPageResponseModel<CommonAtcViewModel> }>()
  ),
  setListResultAction: createAction(
    CommonAtcActionLabels.SET_LIST_RESULT,
    props<{ result: CommonAtcViewModel[] }>()
  ),
  setMedicineResultAction: createAction(
    CommonAtcActionLabels.SET_MEDICINE_RESULT,
    props<{ result: CommonMedicineViewModel[] }>()
  ),
  addMedicineResultAction: createAction(
    CommonAtcActionLabels.ADD_MEDICINE_RESULT,
    props<CommonMedicineViewModel>()
  ),
  setAllDefaultAction: createAction(
    CommonAtcActionLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
